<template>
  <!-- @TODO GENRALIZE AND REMOVE FROM CATEGORY STREAM -->
    <div class="pagination-container mb-5" data-component="pagination">
        <nav class="pagination">
            <ul class="pagination-list flex gap-3 pb-[5.25rem] justify-start">

                <li 
                    class="cursor-pointer" 
                    :class="{ 'display-none': !showFirst }"
                    v-bind="{ page: 1 }"
                >
                    <slot name="number">
                        <a 
                            class="page text-xs border border-black w-10 h-10 flex items-center justify-center"
                            :data-page="1"
                            :href="getHrefForPage(1)"
                            :link="hasRouter ? getLinkTo(1) : null"
                            @click.="hasRouter ? null : go(1)"
                        > 
                            1
                        </a>
                    </slot>
                </li>

                <li 
                    class="cursor-pointer"
                    :class="{ 'display-none': firstVisiblePageNumber <= 2 }"
                >
                    <slot name="points">
                        <a 
                            data-type="dots"
                            class="dots dots-after text-xs border border-black w-10 h-10 flex items-center justify-center"
                        >
                            ...
                        </a>
                    </slot>
                </li>

                <li class="cursor-pointer" 
                    v-for="page in limitedPageNumbers" :key="`page-${page}`">
                    <slot name="number" v-bind="{ page, currentPage }">
                        <a 
                            class="page text-xs border border-black w-10 h-10 flex items-center justify-center"
                            :class="{
                                active: currentPage === page,
                            }"
                            :data-page="page"
                            :key="page"
                            :href="getHrefForPage(page)"
                            :link="hasRouter && currentPage !== page ? getLinkTo(page) : null"
                            @click.prevent="!hasRouter && currentPage !== page ? go(page) : null"
                        > 
                        {{ page }}
                        </a>
                    </slot>
                </li>

                <li :class="{ 'display-none': lastVisiblePageNumber >= total - 1 }" class="cursor-pointer" v-if="showLast">
                    <slot name="points">
                        <a
                            data-type="dots"
                            class="dots dots-after text-xs border border-black w-10 h-10 flex items-center justify-center"
                        >
                            ...
                        </a>
                    </slot>
                </li>

                <li class="cursor-pointer" v-if="showLast">
                    <slot name="number" v-bind="{ page: total }">
                        <a 
                            class="page text-xs border border-black w-10 h-10 flex items-center justify-center"
                            :class="{
                                active: currentPage === page,
                            }"
                            :data-page="page"
                            :key="page"
                            :href="getHrefForPage(total)"
                            :link="hasRouter ? getLinkTo(total) : null"
                            @click.prevent="hasRouter ? null : go(total)"
                        > 
                            {{ total }}
                        </a>
                    </slot>
                </li>
                
            </ul>
        </nav>
    </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'CategoryPagination',
  props: {
    total: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Number,
      default: 5,
    },
    hasArrows: {
      type: Boolean,
      default: true,
    },
    current: {
      type: Number,
      default: 1,
    },
    pageParamName: {
      type: String,
      default: "page",
    },
    baseUrl: {
      type: String,
      default: "",
    },
  },
  data(){
    return {
      page: 1
    }
  },
  computed: {
    hasRouter() {
      return false
    },
    componentIs() {
      return this.hasRouter ? "SfLink" : "SfButton";
    },
    currentPage() {
      return this.hasRouter
        ? this.$route.query[this.pageParamName]
          ? parseInt(this.$route.query[this.pageParamName], 10)
          : 1
        : this.current;
    },
    getPrev() {
      return this.currentPage === this.firstVisiblePageNumber
        ? this.currentPage
        : this.currentPage - 1;
    },
    canGoPrev() {
      return this.currentPage !== this.firstVisiblePageNumber;
    },
    getNext() {
      return this.currentPage === this.lastVisiblePageNumber
        ? this.currentPage
        : this.currentPage + 1;
    },
    canGoNext() {
      return this.currentPage !== this.lastVisiblePageNumber;
    },
    showFirst() {
      return this.firstVisiblePageNumber > 1;
    },
    showLast() {
      return this.lastVisiblePageNumber < this.total;
    },
    listOfPageNumbers() {
      return Array.from(Array(this.total), (_, i) => i + 1);
    },
    limitedPageNumbers() {
      if (this.total <= this.visible) {
        return this.listOfPageNumbers;
      }
      if (this.currentPage < this.visible - Math.floor(this.visible / 2) + 1) {
        return this.listOfPageNumbers.slice(0, this.visible);
      }
      if (
        this.total - this.currentPage <
        this.visible - Math.ceil(this.visible / 2) + 1
      ) {
        return this.listOfPageNumbers.slice(this.total - this.visible);
      }
      return this.listOfPageNumbers.slice(
        this.currentPage - Math.ceil(this.visible / 2),
        this.currentPage + Math.floor(this.visible / 2)
      );
    },
    firstVisiblePageNumber() {
      return this.limitedPageNumbers[0];
    },
    lastVisiblePageNumber() {
      return this.limitedPageNumbers[this.limitedPageNumbers.length - 1];
    },
  },
  methods: {
    go(page) {
      this.$emit("click", page);
    },
    getLinkTo(page) {
      const pageNumber = page.toString();
      if (this.hasRouter) {
        return {
          ...this.$route,
          query: { ...this.$route.query, [this.pageParamName]: page },
        };
      } else {
        return pageNumber;
      }
    },
    getHrefForPage(page) {
      
      const query = { ...this.$route.query };
      
      if (page === 1) {
        delete query[this.pageParamName];
      } else {
        query[this.pageParamName] = page.toString();
      }
      
      if (this.baseUrl) {
        const queryString = Object.keys(query)
          .map(key => `${key}=${query[key]}`)
          .join('&');
        return this.baseUrl + (queryString ? `?${queryString}` : '');
      }
      
      const queryString = Object.keys(query)
        .map(key => `${key}=${query[key]}`)
        .join('&');
      
      return this.$route.path + (queryString ? `?${queryString}` : '');
    },
  }
});
</script>

<style>
.pagination .page.active {
    --tw-bg-opacity: 1;
    background-color: rgb(15 15 15 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
</style>
